/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDRadiusDownRightIcon20Solid = forwardRef('ArrowDRadiusDownRightIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M3.75 4.5a5.75 5.75 0 0 0 5.75 5.75h5.482l-3.366-3.366a1.25 1.25 0 0 1 1.768-1.768l4.44 4.44a2.75 2.75 0 0 1 0 3.889l-4.44 4.439a1.25 1.25 0 0 1-1.768-1.768l3.366-3.366H9.5A8.25 8.25 0 0 1 1.25 4.5v-1a1.25 1.25 0 1 1 2.5 0v1Z" })));
});
